import { Submission } from '../../types';

export const requestSigner = async (
  signerEmail: string,
  urlSlug: string,
  submissionId: string,
): Promise<Submission> => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/submissions/${urlSlug}/${submissionId}/signature/request`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email: signerEmail }),
    credentials: 'include',
  });

  const body = await response.json();

  if (!response.ok || !body.success) {
    const errorMessage = body?.message || 'Failed to delete signer invitation.';
    throw new Error(errorMessage);
  }

  return body.data;
};
